import React, {Fragment} from "react";
import {ContractCard} from "./ContractCard";
import {Grid} from "@mui/material";
import {useFinance} from "~/apps/packages/finance/hooks";
import {LoadingResult} from "~/apps/core/ui/LoadingResult";


export type ContractListProps = {}


export const ContractList = (props: ContractListProps) => {
    const {data, loading} = useFinance();

    return (
        <Grid container direction="column" rowSpacing="16px">
            <LoadingResult loading={loading}/>
            {data && (
                <>
                    <Grid item>
                        <ContractCard balances={data.totalBalance} title="Общая сводка" color="primary"/>
                    </Grid>
                    {data.contracts.map(contract => (
                        <Fragment key={contract.id}>
                            <Grid item>
                                <ContractCard key={contract.id} balances={contract.subtotalBalance}
                                              active={contract.active}
                                              title={`№ ${contract.number}`}/>
                            </Grid>
                        </Fragment>
                    ))}
                </>
            )}
        </Grid>
    );
}